/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class SessionStorageService {
  public window: Window;

  public constructor(window: Window) {
    this.window = window;
  }
  public setItem(key: string, value: string): void {
    this.window.sessionStorage.setItem(key, value);
  }

  public getItem(key: string): string | null {
    return this.window.sessionStorage.getItem(key);
  }

  public removeItem(key: string): void {
    this.window.sessionStorage.removeItem(key);
  }
}
